<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body">
						<div class="DateSelect flex">
							<label *ngIf="ModeSelectID == 0" style="margin-left: 0px; margin-top: 0px; margin-bottom: 0px">Start Date:</label>
							<label *ngIf="ModeSelectID == 1" style="margin-left: 0px; margin-top: 0px; margin-bottom: 0px">Select Date:</label>

							<div style="width: fit-content; margin-left: 10px; margin-top: 0px; margin-bottom: 0px">
								<p-calendar
									[disabled]="IsLoading() == true"
									[(ngModel)]="StartDate"
									(ngModelChange)="onStartDateChange($event)"
									showIcon="true"
									showButtonBar="true"
								></p-calendar>
							</div>

							<label *ngIf="ModeSelectID == 0" style="margin-left: 10px; margin-top: 0px; margin-bottom: 0px">End Date:</label>

							<div *ngIf="ModeSelectID == 0" style="width: fit-content; margin-left: 10px; margin-top: 0px; margin-bottom: 0px">
								<p-calendar
									[disabled]="IsLoading() == true"
									[(ngModel)]="EndDate"
									(ngModelChange)="onEndDateChange($event)"
									showIcon="true"
									showButtonBar="true"
								></p-calendar>
							</div>

							<label style="margin-left: 10px; margin-top: 0px; margin-bottom: 0px">Select:</label>

							<div style="width: fit-content; margin-left: 10px; margin-top: 0px; margin-bottom: 0px">
								<select
									[disabled]="IsLoading() == true"
									class="form-control"
									[(ngModel)]="ModeSelectID"
									(ngModelChange)="onModeChange($event)"
									[style.color]="ModeSelectID == 1 ? 'Red' : 'Black'"
								>
									<option *ngFor="let r of lstMode" [ngValue]="r.ID" [style.color]="r.ID == 1 ? 'Red' : 'Black'">
										{{ r.Desc }}
									</option>
								</select>
							</div>
						</div>

						<div *ngIf="ModeSelectID == 0" class="ScanStatsGrid">
							<label>Total Scans:</label>
							<label class="InfoText">{{ TotalScans }}</label>

							<label>Entry Scans:</label>
							<label class="InfoText">{{ EntryScans }}</label>

							<label>Exit Scans:</label>
							<label class="InfoText">{{ ExitScans }}</label>

							<label>Meal Scans:</label>
							<label class="InfoText">{{ MealScans }}</label>

							<label>Access Scans:</label>
							<label class="InfoText">{{ AccessScans }}</label>

							<label>Timestamp Scans:</label>
							<label class="InfoText">{{ TimestampScans }}</label>

							<label>Event Scans:</label>
							<label class="InfoText">{{ EventScans }}</label>

							<label>Manual Scans:</label>
							<label class="InfoText">{{ ManualScans }}</label>

							<label>Temp IDs Printed:</label>
							<label class="InfoText">{{ TempIDCount }}</label>

							<label>New IDs Printed at ScanStation:</label>
							<label class="InfoText">{{ NewIDCount }}</label>
						</div>

						<div class="flex">
							<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

							<!--INSERT CUSTOM BUTTONS HERE-->
							<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>

							<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
						</div>

						<div style="margin-top: 15px" [style.display]="isShowInfo == true ? 'block' : 'none'">
							<label>&#9900;</label>
							<label style="color: red">Red Text:</label>
							<label> Scan has an alert</label><br />
							<label>&#9900; Total scans: {{ lstScan.length }}</label
							><br />
						</div>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstScan"
						[loading]="ScanLoading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedScan"
						dataKey="ScanID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--PersonName-->
								<th>
									<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ScanDT-->
								<th>
									<!-- <p-columnFilter type="text" field="ScanDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--StationModeDesc-->
								<th>
									<p-columnFilter id="StationModeDesc" field="StationModeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterStationModeDesc
												[ngModel]="value"
												[options]="lstStationModeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ResultDesc-->
								<th>
									<p-columnFilter id="ResultDesc" field="ResultDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterResultDesc
												[ngModel]="value"
												[options]="lstResultDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ScanStation-->
								<th>
									<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterScanStation
												[ngModel]="value"
												[options]="lstScanStation"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ManualDesc-->
								<th>
									<p-columnFilter id="ManualDesc" field="ManualDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterManualDesc
												[ngModel]="value"
												[options]="lstManualDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Facility Name-->
								<th>
									<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterFacilityName
												[ngModel]="value"
												[options]="lstFacilityName"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Facility Location Name-->
								<th>
									<p-columnFilter field="FacilityLocationName" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterFacilityLocationName
												[ngModel]="value"
												[options]="lstFacilityLocationName"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--HasAlertDesc-->
								<th>
									<p-columnFilter id="HasAlertDesc" field="HasAlertDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterHasAlertDesc
												[ngModel]="value"
												[options]="lstHasAlertDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--HasReminderDesc-->
								<th>
									<p-columnFilter id="HasReminderDesc" field="HasReminderDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterHasReminderDesc
												[ngModel]="value"
												[options]="lstHasReminderDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--OnBlockListDesc-->
								<!-- <th>
									<p-columnFilter id="OnBlockListDesc" field="OnBlockListDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterOnBlockListDesc
												[ngModel]="value"
												[options]="lstOnBlockListDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th> -->
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="PersonName">Name<p-sortIcon field="PersonName"></p-sortIcon></th>
								<th pSortableColumn="ScanDT">Scan Date/Time<p-sortIcon field="ScanDT"></p-sortIcon></th>
								<th pSortableColumn="StationModeDesc">Station Mode<p-sortIcon field="StationModeDesc"></p-sortIcon></th>
								<th pSortableColumn="ResultDesc">Scan Result<p-sortIcon field="ResultDesc"></p-sortIcon></th>
								<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
								<th pSortableColumn="ManualDesc">Manual<p-sortIcon field="ManualDesc"></p-sortIcon></th>
								<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
								<th pSortableColumn="FacilityLocationName">Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
								<th pSortableColumn="HasAlertDesc">Scan Has Alert<p-sortIcon field="HasAlertDesc"></p-sortIcon></th>
								<th pSortableColumn="HasReminderDesc">Scan Has Reminder<p-sortIcon field="HasReminderDesc"></p-sortIcon></th>
								<!-- <th pSortableColumn="OnBlockListDesc">Student On Block List<p-sortIcon field="OnBlockListDesc"></p-sortIcon></th> -->
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-Scan>
							<tr [pSelectableRow]="Scan" (dblclick)="onRowDblClick(Scan)">
								<td
									*ngFor="let col of cols"
									style="font-weight: bold"
									[ngStyle]="{
										color: Scan.HasAlert == 1 ? 'red' : 'black'
									}"
								>
									{{ Scan[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>

<caass-student-scan-view-details *ngIf="SelectedScan != undefined" [SelectedEntry]="SelectedScan"> </caass-student-scan-view-details>

<caass-student-scan-view-manual *ngIf="SelectedScan != undefined && SelectedScan.ManualDesc == 'Yes'" [SelectedEntry]="SelectedScan">
</caass-student-scan-view-manual>

<caass-student-scan-view-alerts *ngIf="SelectedScan != undefined && SelectedScan.HasAlert == 1" [SelectedEntry]="SelectedScan">
</caass-student-scan-view-alerts>

<caass-student-scan-view-reminders *ngIf="SelectedScan != undefined && SelectedScan.HasReminder == 1" [SelectedEntry]="SelectedScan">
</caass-student-scan-view-reminders>

<caass-student-scan-view-block-list *ngIf="SelectedScan != undefined && SelectedScan.OnBlockList == 1" [SelectedEntry]="SelectedScan">
</caass-student-scan-view-block-list>
